module.exports = __webpack_public_path__ + "img/02.139712a8.png";